import { gsap } from 'gsap';

/**
 * Module Partners Slider - Version simplifiée et fluide
 * Gestion du slider de logos de partenaires avec animation GSAP optimisée
 */

export function initPartnersSliders() {
    const containers = document.querySelectorAll('.partners-slider-container');
    
    containers.forEach((container) => {
        initSinglePartnerSlider(container);
    });
}

/**
 * Initialise un slider Partners spécifique
 * @param {HTMLElement} container - Le container du slider
 */
function initSinglePartnerSlider(container) {
    if (!container) return;

    const slider = container.querySelector('.partners-slider');
    if (!slider) return;

    // Configuration depuis les data attributes
    const autoplay = container.dataset.autoplay !== 'false';
    const speed = parseInt(container.dataset.speed) || 3;

    // Variables pour l'animation
    let tween = null;
    let isPaused = false;

    // Calculer la largeur totale du contenu
    function getTotalWidth() {
        return slider.scrollWidth;
    }

    // Calculer la largeur visible
    function getVisibleWidth() {
        return container.offsetWidth;
    }

    // Démarrer l'animation fluide
    function startAnimation() {
        if (!autoplay || isPaused) return;

        // Arrêter l'animation existante
        if (tween) tween.kill();

        const totalWidth = getTotalWidth();
        const visibleWidth = getVisibleWidth();
        
        // Si le contenu est plus petit que le container, pas besoin d'animation
        if (totalWidth <= visibleWidth) return;

        // Distance à parcourir (la moitié car on a dupliqué le contenu)
        const distance = totalWidth / 4; // Car on a 4x le même contenu

        // Durée basée sur la distance (vitesse constante)
        const duration = (distance / 100) * speed; // Ajuster selon les besoins

        // Animation continue et fluide
        tween = gsap.fromTo(slider, 
            { x: 0 },
            {
                x: -distance,
                duration: duration,
                ease: "none",
                repeat: -1,
                modifiers: {
                    x: function(x) {
                        // Boucle infinie fluide
                        return (parseFloat(x) % distance) + "px";
                    }
                }
            }
        );
    }

    // Arrêter l'animation
    function stopAnimation() {
        if (tween) {
            tween.pause();
        }
    }

    // Reprendre l'animation
    function resumeAnimation() {
        if (tween) {
            tween.resume();
        } else {
            startAnimation();
        }
    }

    // Events pour pause/reprise au hover
    container.addEventListener('mouseenter', () => {
        isPaused = true;
        stopAnimation();
    });

    container.addEventListener('mouseleave', () => {
        isPaused = false;
        resumeAnimation();
    });

    // Gestion du redimensionnement
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (tween) tween.kill();
            startAnimation();
        }, 150);
    });

    // Démarrage initial
    if (autoplay) {
        // Petit délai pour s'assurer que le DOM est prêt
        requestAnimationFrame(() => {
            setTimeout(startAnimation, 100);
        });
    }
}
